const getters = {
  getOrgs: state => state.orgs,
  getOrg: state => state.org,
  getOrgToUpdate: state => state.orgToUpdate,
  getIsOrgLoading: state => state.isOrgLoading,
  getOrgError: state => state.orgError,
};

export default getters;
